module.exports = __webpack_public_path__ + "img/jonas_portrait_ocular.a8fa16d4.jpg";